import moment from "moment";
import { useRef, useState } from "react";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import useWindowSize from "../../../hooks/useWindowSize";
import { useFetchDetailArticle } from "../../../networks";
import { getStaticImg } from "../../../utils/function";
import Button from "../../atoms/Button";
import Text from "../../atoms/Text";
import dataRule from "../MegaPopUp/datarule.json";
import dataPS from "../MegaPopUp/datapoinsupporter.json";
import TimelinePathPopUp from "../v2/TimelinePathPopUp";
import CityListPopup from "../v2/CityListPopup";
import InitialRegistPopup from "../v2/InitialRegistPopup";
import ActivityPopupContent from "../../../pages/v2/HomeDetails/Activity/ActivityPopupContent";
import classNames from "classnames";
const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

export default function MegaPopUp({
  title = "Article",
  desc,
  date = "date",
  subTitle = "subTitle News",

  ...props
}) {
  const contentCurrentPostitionRef = useRef(0);
  const modalContentRef = useRef(null);
  const modalContainerRef = useRef(null);

  const { openPopup: isShow } = usePageContextState();
  const { setOpenPopUp: toglePopUp } = usePageContextFunction();
  const { size: screenSize } = useWindowSize();

  const [close, setClose] = useState(false);
  const [touchPosition, setTouchPosition] = useState(0);
  const [isCanSwipe, setIsCanSwipe] = useState(false);

  const datax = isShow.data;
  const currentCity = isShow?.currentCity;
  const typePopUp = isShow?.typePopUp;
  const classNamePopupContent = isShow?.classNamePopupContent || "";
  const classNamePopupContainer = isShow?.classNamePopupContainer || "";
  const classNamePopupParent = isShow?.classNamePopupParent || "";
  const invertCloseColor = isShow?.invertCloseColor || false;
  const closePosition = isShow?.closePosition || "inside";
  const iconCloseClassname = isShow?.iconCloseClassname || "";
  const isDisableHandleTouchMove = isShow?.isDisableHandleTouchMove || false;
  document.body.style.overflow = isShow.state === true ? "hidden" : "auto";

  const isMobileView = (screenSize?.width || 0) <= 768;

  const size = screenSize?.width >= 1000 ? "big" : "small";

  const { data: dataArticleDetail } = useFetchDetailArticle(
    datax?.slug,
    currentCity
  );

  const data =
    currentCity === "rule"
      ? dataRule
      : currentCity === "supporter"
      ? dataPS
      : dataArticleDetail?.data?.data;

  const city = currentCity === "rule" ? "Jakarta" : currentCity;

  const closePopUp = () => {
    setClose(true);
  };

  const getTouchPosition = (event) => {
    event.persist();
    if (window.TouchEvent && event.nativeEvent instanceof TouchEvent) {
      return event.nativeEvent.touches[0]
        ? event.nativeEvent.touches[0].clientX
        : event.nativeEvent.changedTouches[0].clientX;
    }

    if (event.nativeEvent instanceof MouseEvent) {
      return event.nativeEvent.screenX;
    }

    return 0;
  };

  const handleTouchStart = (event) => {
    const touchDown = getTouchPosition(event);

    // set touch start position
    contentCurrentPostitionRef.current = touchDown;

    setTouchPosition(touchDown);
  };

  const handleTouchMove = (event) => {
    if (!modalContentRef?.current) return;

    const touchDown = touchPosition;

    const currentPosition = getTouchPosition(event);

    if (touchDown - currentPosition >= 50) {
      setClose(true);
    }
  };

  const handleTouchEnd = () => {
    modalContainerRef.current.style.touchAction = "auto";
  };

  window.addEventListener("click", () => {
    const carrier = document.getElementById("ultimate");

    carrier?.addEventListener("click", function (e) {
      if (document.getElementById("popUpModal").contains(e.target)) {
        return;
      } else {
        setClose(true);
      }
    });
  });

  window.addEventListener("popstate", function (e) {
    setClose(true);
  });

  //close popup delay for animation
  close
    ? setTimeout(() => {
        toglePopUp(false);
        setClose(false);
      }, 300)
    : clearTimeout();

  return (
    <>
      {isShow.state && (
        <>
          <div
            className={`mega-pop-up__carrier --${
              close ? "close" : "show"
            }-carrier ${classNamePopupParent}`}
            id="ultimate"
            onTouchStart={handleTouchStart}
            onTouchMove={!isDisableHandleTouchMove ? handleTouchMove : null}
            onTouchEnd={handleTouchEnd}
          >
            {closePosition === "outside" && (
              <img
                className={classNames(
                  "mega-pop-up__close-el ml-auto right-[20px] left-0 absolute"
                )}
                src={
                  invertCloseColor
                    ? `${getStaticImg("icon/sa-close-white.svg")}`
                    : `${getStaticImg("icon/sa-close.svg")}`
                }
                onClick={closePopUp}
              />
            )}
            <div
              className={`mega-pop-up mega-show --${
                close ? "close" : "show"
              }-popUp ${classNamePopupContent}`}
              id="popUpModal"
              ref={modalContentRef}
            >
              <div
                ref={modalContainerRef}
                className={classNames(
                  classNamePopupContainer,
                  "mega-pop-up__container",
                  typePopUp === "registration-city-list"
                    ? "md:w-auto md:h-auto"
                    : ""
                )}
              >
                <div
                  className={classNames(
                    "mega-pop-up__content",
                    typePopUp === "custom-children" ? "!pt-0" : "",
                    typePopUp === "registration-city-list" ? "md:pb-2" : ""
                  )}
                >
                  <div
                    className={classNames(
                      classNamePopupContainer,
                      "mega-pop-up__close",
                      typePopUp === "registration-city-list"
                        ? "md:h-[45px]"
                        : ""
                    )}
                  >
                    {closePosition === "inside" && (
                      <img
                        className={classNames(
                          "mega-pop-up__close-el ml-auto",
                          iconCloseClassname
                        )}
                        src={
                          invertCloseColor
                            ? `${getStaticImg("icon/sa-close-white.svg")}`
                            : `${getStaticImg("icon/sa-close.svg")}`
                        }
                        onClick={closePopUp}
                      />
                    )}
                  </div>
                  {typePopUp === "timeline" ? (
                    <>
                      {isMobileView ? (
                        <h4
                          style={{
                            width: "100%",
                            textAlign: "Center",
                            marginBottom: 0,
                          }}
                        >
                          Piala by.U {city.toUpperCase()}
                        </h4>
                      ) : (
                        <h1
                          style={{
                            width: "100%",
                            textAlign: "Center",
                            marginBottom: 0,
                          }}
                        >
                          Piala by.U {city.toUpperCase()}
                        </h1>
                      )}

                      <TimelinePathPopUp data={datax} />
                    </>
                  ) : typePopUp === "registration-city-list" ? (
                    <>
                      {isMobileView ? (
                        <h4
                          style={{
                            width: "100%",
                            textAlign: "Center",
                            marginBottom: 8,
                            fontSize: 16,
                          }}
                        >
                          Pilih Kota Pendaftaran
                        </h4>
                      ) : (
                        <h1
                          style={{
                            width: "100%",
                            textAlign: "Center",

                            fontSize: 20,
                          }}
                        >
                          Pilih Kota Pendaftaran
                        </h1>
                      )}

                      <CityListPopup data={datax} />
                    </>
                  ) : typePopUp === "show-info-regist" ? (
                    <>
                      <InitialRegistPopup
                        city={city}
                        data={isShow?.data}
                        registStartDate={isShow?.registStartDate}
                        registEndDate={isShow?.registEndDate}
                        registAnnounceDate={isShow?.registAnnounceDate}
                      />
                    </>
                  ) : typePopUp === "custom-children" ? (
                    isShow?.children
                  ) : typePopUp === "activity" ? (
                    <ActivityPopupContent data={datax} currentCity={city} />
                  ) : (
                    <>
                      {data?.key_visual && (
                        <div className="mega-pop-up__img">
                          <img
                            className="mega-pop-up__img-title"
                            src={
                              size === "big"
                                ? imgPath + data?.key_visual
                                : imgPath + data?.key_visual_mobile
                              //   ? func.getStaticImg("/illustration/default-image.png")
                              //   : func.getStaticImg("/illustration/default-image.png")
                            }
                          />
                        </div>
                      )}
                      <div className="mega-pop-up__words">
                        {currentCity === "rule" ||
                        currentCity === "supporter" ? (
                          <>
                            <Text
                              className="mega-pop-up__title"
                              color="dark"
                              weight="bold"
                              size="large"
                            >
                              {data?.title}
                              {/* {"MAIN HEADLINE TITLE ARTICLE #1"} */}
                            </Text>
                            {currentCity === "rule" && (
                              <Text
                                className="mega-pop-up__words-date"
                                weight="bold"
                                color="grey"
                                style={{ marginTop: 32 }}
                              >
                                {city.charAt(0).toUpperCase() + city.slice(1)},{" "}
                                {moment(data?.created_at).format(
                                  "DD MMMM YYYY"
                                )}
                              </Text>
                            )}
                          </>
                        ) : (
                          <>
                            <Text
                              className="mega-pop-up__words-date"
                              weight="bold"
                            >
                              {city.charAt(0).toUpperCase() + city.slice(1)},{" "}
                              {moment(data?.created_at).format("DD MMMM YYYY")}
                            </Text>
                            <Text
                              className="mega-pop-up__title"
                              color="dark"
                              weight="bold"
                              size="large"
                            >
                              {data?.title}
                              {/* {"MAIN HEADLINE TITLE ARTICLE #1"} */}
                            </Text>
                          </>
                        )}

                        {/* <Text className="mega-pop-up__words-subTitle">
                      {data?.subtitle}
                    </Text> */}
                        <div
                          className="mega-pop-up__words-desc"
                          dangerouslySetInnerHTML={{ __html: data?.content }}
                          // dangerouslySetInnerHTML={{ __html: textPH }}
                        ></div>
                        {data?.has_button == 1 && (
                          <div
                            className={`mega-pop-up__words-btn-wrap --${
                              close ? "close" : "show"
                            }-carrier `}
                            id="btn"
                          >
                            <Button
                              variant={"primary-orange"}
                              className="mega-pop-up__words-button"
                              onClick={() =>
                                window.open(`${data.button_url}`, "_blank")
                              }
                            >
                              {data?.button_text}
                            </Button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
